// extracted by mini-css-extract-plugin
export default {"menu":"KxBlSqvjPRPhcE9BuTWI","dateSwitcher":"YhckbKujg5tQGBcEVVB0","datePickerContainer":"gMQDphyOXEKdSipKqbTE","placeHolderShimmer":"tjPb6PmgLG1rsZGVacrE"};